import React, { Component } from 'react';
import NotaFiscalCte from './NotaFiscalCte';
import { withRouter, Link } from 'react-router-dom';
import ReactToPrint from 'react-to-print';
import { connect } from 'react-redux';
import qs from 'qs';
import { PERFIL_ADMIN, getAdminEmpresa, getGestorEmpresa } from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import buscarEncomenda from '../../actions/encomenda/buscarEncomenda';

class PainelNotaFiscalCte extends Component {

    constructor(props) {
        super(props);

        this.state = {
            referenciaSelecionada: null
        }
    }

    componentDidMount() {
        if (this.props.empresaSelecionada.id) {
            const parametros = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
            
            if (parametros.encomenda) {
                this.setState({
                    referenciaSelecionada: React.createRef()
                });
                
                this.props.buscarEncomenda(parametros.encomenda, this.props.empresaSelecionada.id);
            }
        } else {
            this.props.history.push('/painel-encomendas')
        }
    }

    recuperarNomeArquivo() {
        return 'nota-fiscal'
    }

    exibirBotoes() {
        return (
            <React.Fragment>
                <Link className="mt-4 ml-2 mr-4" to="/painel-encomendas">
                    <button className='btn btn-laranja'>Concluir</button>
                </Link>
                <ReactToPrint
                    trigger={() => <button disabled={!this.state.referenciaSelecionada}
                        className="btn btn-laranja">IMPRIMIR
                    </button>}
                    content={() => document.querySelector('#notaFiscalCteOs')}
                    documentTitle={this.recuperarNomeArquivo()}
                />
            </React.Fragment>
        )
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN, getAdminEmpresa(this.props.empresaSelecionada.id),
                getGestorEmpresa(this.props.empresaSelecionada.id)]}>
                {this.exibirBotoes()}
                <NotaFiscalCte ref={this.state.referenciaSelecionada} />
                {this.exibirBotoes()}
            </Autorizacao>
        )
    }
}


export const mapStateToProps = state => (
    {
        empresaSelecionada: state.empresaSelecionada,
    });

export default withRouter(connect(mapStateToProps,
    {
        buscarEncomenda
    })(PainelNotaFiscalCte))